module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-1.dc9a29f5.png";